import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-add-staff-marketing',
  templateUrl: './add-staff-marketing.component.html',
  styleUrls: ['./add-staff-marketing.component.scss']
})
export class AddStaffMarketingComponent implements OnInit {

  @Output() validState: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => this.validState.emit(true), 2);
  }

}
